var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationTelexNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7913 9.07335C30.3683 9.07335 31.6466 10.3517 31.6466 11.9287H32.4558C32.4558 9.90486 30.8151 8.26422 28.7913 8.26422H26.1349C25.6135 8.26422 25.1909 7.84158 25.1909 7.32024V4.66381C25.1909 2.63997 23.5502 0.999325 21.5264 0.999325H21.0029V1.80845H21.5264C23.1034 1.80845 24.3817 3.08683 24.3817 4.66381V7.32024C24.3817 8.28845 25.1666 9.07335 26.1349 9.07335H28.7913Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0954 26.5954C18.0954 26.8189 18.2766 27 18.5 27H30.7028C31.6711 27 32.4559 26.2153 32.4559 25.2469V11.0742C32.4559 9.42741 31.8016 7.84757 30.6372 6.68314L26.7728 2.81874C25.6084 1.65432 24.0285 1 22.3817 1H12.7531C11.7847 1 11 1.78475 11 2.75311V10.3438C11 10.5672 11.1811 10.7483 11.4046 10.7483C11.628 10.7483 11.8091 10.5672 11.8091 10.3438V2.75311C11.8091 2.2316 12.2316 1.80913 12.7531 1.80913H22.3817C23.814 1.80913 25.188 2.37822 26.2007 3.39089L30.0651 7.25528C31.0777 8.26795 31.6468 9.64197 31.6468 11.0742V25.2469C31.6468 25.7684 31.2243 26.1909 30.7028 26.1909H18.5C18.2766 26.1909 18.0954 26.372 18.0954 26.5954Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 14.405C19 14.6284 19.1391 14.8096 19.3107 14.8096H27.6873C27.859 14.8096 27.9981 14.6284 27.9981 14.405C27.9981 14.1816 27.859 14.0004 27.6873 14.0004H19.3107C19.1391 14.0004 19 14.1816 19 14.405Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19.4587C19 19.6822 19.1122 19.8633 19.2506 19.8633H27.7493C27.8877 19.8633 27.9999 19.6822 27.9999 19.4587C27.9999 19.2353 27.8877 19.0542 27.7493 19.0542H19.2506C19.1122 19.0542 19 19.2353 19 19.4587Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.71429,
    cy: 21.7143,
    r: 7.71429,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85093 16.2861C8.50496 16.2861 9.03516 16.8163 9.03516 17.4704V22.3019C9.03516 22.9559 8.50496 23.4861 7.85093 23.4861C7.19689 23.4861 6.6667 22.9559 6.6667 22.3019V17.4704C6.6667 16.8163 7.19689 16.2861 7.85093 16.2861ZM7.85093 24.8861C8.50496 24.8861 9.03516 25.4163 9.03516 26.0704V26.1019C9.03516 26.7559 8.50496 27.2861 7.85093 27.2861C7.19689 27.2861 6.6667 26.7559 6.6667 26.1019V26.0704C6.6667 25.4163 7.19689 24.8861 7.85093 24.8861Z",
    fill: "#F47A36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationTelexNegative);
export default __webpack_public_path__ + "static/media/notification-telex-negative.e53be62e4367c478d66118a8bc44c740.svg";
export { ForwardRef as ReactComponent };